import React from 'react';
import { FormSection, change as formChange, autofill } from 'redux-form';
import { TextField, BoxDouble, RadioField, Section } from 'jbc-front/components/Form';
import { DeleteSquare } from 'jbc-front/components/icons';
import ActionButton from 'jbc-front/components/ActionButton';
import { maxLength9, maxLength20, isNumber, bankThaiEng } from 'src/utils/CustomValidators';
import { EMPLOYEE_FORM } from 'src/constants/FormNames';
import BankSearchModalWrapper from 'src/components/BankSearchModalWrapper';
import { withTranslation } from 'react-i18next';

class BankItemSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSearchBankModalOpen: false,
      selectedBank: undefined
    };
  }

  // 支給口座設定はリセットされます。
  onDeleteBank = () => {
    const { dispatch, remove, bonusPaymentBanks, payPaymentBanks } = this.props;
    if (bonusPaymentBanks) {
      const unSelectBank = bonusPaymentBanks.map(item => ({ ...item, employeeBankId: undefined }));
      dispatch(formChange(EMPLOYEE_FORM, 'bonusPaymentBanks', unSelectBank));
    }
    if (payPaymentBanks) {
      const unSelectBank = payPaymentBanks.map(item => ({ ...item, employeeBankId: undefined }));
      dispatch(formChange(EMPLOYEE_FORM, 'payPaymentBanks', unSelectBank));
    }
    remove();
  };

  render() {
    const { showModal, isModalOpen: isOpen, hideModal } = this.props;
    const { formKey, depositTypes, index, children, dispatch } = this.props;

    return (
      <div>
        <Section
          title={`${this.props.t('features.Employees.components.BankItemSection.bank_account_information')} ${index + 1}`}
          icon={<DeleteSquare onClick={this.onDeleteBank} />}
        >
          <FormSection name={formKey}>
            <ActionButton onClick={showModal} className="u-mb20">
              {this.props.t('features.Employees.components.BankItemSection.serch_bank_code')}
            </ActionButton>

            <BankSearchModalWrapper
              isOpen={isOpen}
              hideModal={hideModal}
              onSelect={(bank, branch) => {
                this.setState({
                  isSearchBankModalOpen: false
                });
                dispatch(autofill(EMPLOYEE_FORM, `${formKey}.bankId`, bank.id));
                dispatch(autofill(EMPLOYEE_FORM, `${formKey}.bankCode`, bank.bankCode));
                dispatch(autofill(EMPLOYEE_FORM, `${formKey}.bankShortName`, bank.shortName));
                dispatch(autofill(EMPLOYEE_FORM, `${formKey}.bankName`, bank.name));
                dispatch(autofill(EMPLOYEE_FORM, `${formKey}.bankBranchId`, branch.id));
                dispatch(autofill(EMPLOYEE_FORM, `${formKey}.branchCode`, branch.branchCode));
                dispatch(autofill(EMPLOYEE_FORM, `${formKey}.branchName`, branch.name));
              }}
            />

            <BoxDouble>
              <TextField
                label={this.props.t('features.Employees.components.BankItemSection.bank_code')}
                name="bankCode"
                validate={[isNumber, maxLength9]}
                maxLength="9"
              />
              <TextField label={this.props.t('features.Employees.components.BankItemSection.bank_short_name')} name="bankShortName" maxLength="256" />
            </BoxDouble>
            <TextField label={this.props.t('features.Employees.components.BankItemSection.bank_name')} name="bankName" maxLength="256" />
            <BoxDouble>
              <TextField
                label={this.props.t('features.Employees.components.BankItemSection.branch_code')}
                name="branchCode"
                validate={[isNumber, maxLength9]}
                maxLength="9"
              />
              <TextField label={this.props.t('features.Employees.components.BankItemSection.branch_name')} name="branchName" maxLength="256" />
            </BoxDouble>

            <RadioField label={this.props.t('features.Employees.components.BankItemSection.account_type')} name="depositType" options={depositTypes} />

            <BoxDouble>
              <TextField
                label={this.props.t('features.EmployeeBonus.ShowBonusFbDataPage.bank_account_number')}
                type="text"
                name="accountNumber"
                validate={[isNumber, maxLength20]}
                maxLength="20"
              />
              <TextField label={this.props.t('features.Employees.components.BankItemSection.account_holder_name')} type="text" name="accountHolder" validate={[bankThaiEng]} />
            </BoxDouble>

            {children}
          </FormSection>
        </Section>
      </div>
    );
  }
}

export default withTranslation('translation')(BankItemSection);
